import { useReducer } from "react";
import { ContentEvaluationModel } from "../model/content-evaluation-model";

const containerEvaluationReducer = (
    state: ContentEvaluationModel.ContainerEvaluationState,
    action: ContentEvaluationModel.ContainerEvaluationAction
): ContentEvaluationModel.ContainerEvaluationState => {
    switch (action.type) {
        case "INIT_CONTAINERS":
            const newState = {};
            action.containerIds.forEach(id => {
                newState[id] = { loading: true };
            });
            return newState;
        case "SET_LOADING":
            return {
                ...state,
                [action.containerId]: {
                    ...state[action.containerId],
                    loading: action.loading
                }
            };
        case "SET_RESULT":
            return {
                ...state,
                [action.containerId]: {
                    ...state[action.containerId],
                    loading: false,
                    result: action.result,
                    error: undefined
                }
            };
        case "SET_ERROR":
            return {
                ...state,
                [action.containerId]: {
                    ...state[action.containerId],
                    loading: false,
                    error: action.error,
                    result: undefined
                }
            };
        case "CLEAR_ALL":
            return {};
        default:
            return state;
    }
};

export const useContainerEvaluationState = () => {
    const [containerEvaluationState, dispatch] = useReducer(containerEvaluationReducer, {});

    const hasAnyContainerLoading = () => {
        return Object.values(containerEvaluationState).some(state => state.loading);
    };

    const hasAnyContainerResults = () => {
        return Object.values(containerEvaluationState).some(state => state.result);
    };

    const scrollToContainer = (containerId: string) => {
        const element = document.getElementById(`container-result-${containerId}`);
        if (element) {
            element.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest"
            });
        }
    };

    return {
        containerEvaluationState,
        dispatch,
        hasAnyContainerLoading,
        hasAnyContainerResults,
        scrollToContainer
    };
};
